module.exports = __webpack_public_path__ + "static/media/GB-WLS.ef900ea4.svg";